module.exports = __webpack_public_path__ + "img/view.834f9d14.svg";